<template>
  <div id="sign-up">
    <section class="content">
      <p class="title-second">
        需求发布流程
      </p>
      <process />
      <section class="mt-10" style="position: relative">
        <publish-from :form="form" modal="view" />
        <timer class="time-positon" :end-time="endTime" :trace-status="traceStatus" />
      </section>
      <ux-divider></ux-divider>
      <sign-form v-if="showSignForm" :form="formSign" :modal="modal" @signDataChange="signDataChange" />
      <section>
        <ux-row>
          <ux-col :offset="4">
            <operate :state="applyStatus" :trace-status="traceStatus" :end-time="endTime" @cancelSign="cancelSign" />
          </ux-col>
        </ux-row>
      </section>

      <ux-modal v-model="cancelVislable">
        <div slot="title">
          温馨提示
        </div>
        <div class="content">
          <span>
            <img src="../assets/info.png" alt="">
          </span>
          <span class="ml-10">取消报名将影响平台评分，是否确认？</span>
        </div>
        <div slot="footer">
          <ux-button type="success" @click="confirmCancel">
            确定
          </ux-button>
          <ux-button @click="cancelC">
            取消
          </ux-button>
        </div>
      </ux-modal>

      <ux-modal v-model="noAccessVisible">
        <div slot="title">
          提示
        </div>
        <div class="content">
          <div>尚不具备【营销定制】类目资质，请新增后再试</div>
          <a @click="openAccess">
            点击新增
          </a>
        </div>
        <div slot="footer">
          <ux-button type="success" @click="confirmNoAccess">
            确定
          </ux-button>
          <ux-button @click="cancelNoAccess">
            取消
          </ux-button>
        </div>
      </ux-modal>
    </section>

    <section class="content mt-20">
      <div class="header-info-isv">
        <span>投标信息：</span>
        ({{ applyed }}/{{ total }})
      </div>
      <ux-divider class="custom-divider"></ux-divider>
      <div class="isv-list mb-20">
        <div v-for="item in isvInfo" :key="item.id" class="isv-card-item">
          <div class="isv-card-brand-wrapper">
            <img width="100%" :src="item.brand" alt="">
          </div>
          <div class="isv-card-info ml-10">
            <div class="isv-card-info-name">
              {{ item.cmpyName }}
            </div>
            <div>
              <div class="text-over">
                公司地址：{{ item.cmpyContactAddress }}
              </div>
              <div class="text-over">
                公司邮箱：{{ item.cmpyEmail }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// http://uimgpre.cnsuning.com/uimg/API/KFFW/151011183674542378.png
import UxMessage from '@cloud-sn/uxcool/es/message';
import timer from './component/timer';
import process from './component/process';
import publishFrom from './component/publish_form';
import signForm from './component/sign_form';
import operate from './component/fws_operate';
import {squareService} from '../service';
import { gotoFwsProviderQualification } from '@/common/utils/utils.js';

export default {
  components: {
    timer,
    process,
    publishFrom,
    signForm,
    operate
  },
  data() {
    return {
      endTime: '',
      form: {
        
      },
      formSign: {
        quotePrice: '',
        description: '',
        applyEnclosureUrl: ''
      },
      applyed: 0,
      total: 0,
      isvInfo: [],
      modal: 'add',
      applyStatus: '',
      traceStatus: '',
      timeOver: true,
      cancelVislable: false,
      noAccessVisible: false,
    }
  },
  computed: {
    showSignForm() {
      let flag = false;
      if(!this.timeOver && this.traceStatus === '10') {
        flag = true;
      } else if(this.timeOver && this.modal === 'view') {
        flag = true;
      }
      return flag
    }
  },
  created() {
    this.customizedCode = this.$route.query.customizedCode;
    this.getDemandDetail();
  },
  methods: {
    openAccess() {
      gotoFwsProviderQualification();
    },
    confirmNoAccess() {
      this.noAccessVisible = false;
    },
    cancelNoAccess() {
      this.noAccessVisible = false;
    },
    confirmCancel() {
      const params = {
        customizedCode: this.customizedCode
      }
      squareService.cancelSign(params).then(() => {
        this.cancelVislable = false;
        UxMessage.success('取消报名成功');
        this.$router.push({name: 'square'})
      }, (errMsg) => {
        UxMessage.error(errMsg);
      })
    },
    cancelC() {
       this.cancelVislable = false;
    },
    getDemandDetail() {
      const params = {
        customizedCode: this.customizedCode,
        type: 'fws'
      }
      squareService.getTaskDetail(params).then((detail) => {
        const {isvEnterNameOutput, isvDetailList, traceStatus, applyNumber, alreadyApplyNumber, ...baseInfo} = detail;
        this.traceStatus = traceStatus;
        this.form = baseInfo;
        this.endTime = baseInfo.deadlineDate
        this.modal = isvEnterNameOutput && isvEnterNameOutput.quotePrice ? 'view' : 'add';
        this.timeOver = this.judgeTimeOver(baseInfo.deadlineDate);
        if(isvEnterNameOutput && isvEnterNameOutput.quotePrice) {
          const {quotePrice, description, applyEnclosureUrl, applyStatus } = isvEnterNameOutput;
          this.formSign.quotePrice = quotePrice;
          this.formSign.description = description;
          this.formSign.applyEnclosureUrl = applyEnclosureUrl;
          this.applyStatus = applyStatus;
        }
        this.applyed = alreadyApplyNumber || '0';
        this.total = applyNumber && applyNumber !== '0' ? applyNumber : '不限'
        this.isvInfo = isvDetailList;
      })
    },
    judgeTimeOver(deadlineDate) {
      const endTime = `${deadlineDate} 23:59:59`
      const now = new Date().getTime();
      const end = new Date(endTime).getTime();
      return end - now < 0
    },
    signDataChange(data) {
      const params = {
        customizedCode: this.customizedCode
      }
      Object.assign(params, data);
      squareService.signUp(params).then((res) => {
        UxMessage.success('报名成功')
        this.$router.push({name: 'square'})
      }, (errMsg) => {
        if(errMsg === '没有报名资质') {
          this.noAccessVisible = true;
        } else {
          UxMessage.error(errMsg)
        }
        
      })
    },
    cancelSign() {
      this.cancelVislable = true;
    }
  }
}
</script>
<style scope>
.time-positon {
  position:absolute;
  right: 0px;
  top: 0px
}
.isv-list {
  display: flex;
  flex-wrap: wrap;

}
.isv-card-item {
  width: 370px;
  height: 80px;
  display: flex;
  border-right: 1px solid #cccccc;
  margin-right: 20px;
  margin-bottom: 20px;
}
.isv-card-item:nth-child(3n) {
  border-right: none;
  margin-right: 0px;
}
.isv-card-brand-wrapper {
  height: 80px;
  width: 80px;
}
.isv-card-info {
  width: 270px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.isv-card-info-name {
  font-size: 14px;
  font-weight: 600;
}
.header-info-isv {
  font-size: 15px;
  color: #333333;
  font-weight: 600;
}
.custom-divider {
  margin: 10px 0 20px;
}
</style>